import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { sntTranslate } from "src/app/support/translate";
import { flattenDeep, sortBy, startCase } from "es-toolkit";
import { Race } from "src/app/backend/models/race/race";

@Injectable()
export class RaceBackend {
  readonly #http = inject(HttpClient);

  listAll(): Observable<Race[]> {
    return this.#http
      .get<Race[][]>(`${environment.snoots.api.directory}/breeds`)
      .pipe(
        map((listOfRaces: Race[][]) => {
          return flattenDeep(listOfRaces).map(({ key, value }) => ({
            key,
            value: sntTranslate(value)
          }));
        }),
        map((races: Race[]) => {
          return sortBy(races, [(x) => startCase(x.value)]);
        })
      );
  }

  list(specie: string): Observable<Race[]> {
    return this.#http
      .get<Race[]>(`${environment.snoots.api.directory}/breeds/${specie}`)
      .pipe(
        map((races) =>
          races.map((x) => ({
            key: x.key,
            value: sntTranslate(x.value)
          }))
        )
      );
  }

  findOne(specie: string, breed: string): Observable<Race> {
    return this.list(specie).pipe(
      map((list) => list.find((x) => x.key === breed)!)
    );
  }
}
